<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-02 17:30:08
 * @FilePath: /teacher-h5/src/demo/radio.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Radio 单选框
      </h1>
      <div>
        <div class="mb-20">
          <a-radio>Radio</a-radio>
          <a-radio default-checked>
            Radio
          </a-radio>
          <a-radio :default-checked="false" disabled="disabled">
            Disabled
          </a-radio>
          <a-radio default-checked disabled="disabled">
            Disabled
          </a-radio>
        </div>
        <div class="mb-20">
          <a-radio-group v-model="value" @change="onChange">
            <a-radio :style="radioStyle" :value="1">
              Option A
            </a-radio>
            <a-radio :style="radioStyle" :value="2">
              Option B
            </a-radio>
            <a-radio :style="radioStyle" :value="3">
              Option C
            </a-radio>
            <a-radio :style="radioStyle" :value="4">
              More...
              <a-input v-if="value === 4" :style="{ width: 100, marginLeft: 10 }" />
            </a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: 1,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      }
    }
  },
  methods: {
    onChange(e) {
      console.log('radio checked', e.target.value)
    }
  }
}
</script>

<style>
</style>